






























































































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'
import moment from 'moment'

@Component
export default class ModalRegraIndicacaoIncluir extends Vue {
  $refs: {
    form: any
  }

  dicaNumeric: string = 'Use somente números inteiros ou decimais separados por ponto (.)'
  formRules: any = {
    valid: true,
    descricao: [(v: any) => !!v || 'Campo obrigatório'],
    prestadorIndicadorId: [(v: any) => !!v || 'Campo obrigatório'],
    profissionalExecutanteIndicadoId: [(v: any) => !!v || 'Campo obrigatório'],
    profissionalExecutanteIdAtribuir: [(v: any) => !!v || 'Campo obrigatório'],
    qtdeLimiteMinimoInicial: [(v: any) => !!v || 'Campo obrigatório'],
    percentualAteLimite: [(v: any) => !!v || 'Campo obrigatório'],
    vigenciaInicio: [(v: any) => !!v || 'Campo obrigatório'],
  }

  menuInicioVigencia: boolean = false
  menuFimVigencia: boolean = false
  searchProfissional: any = {
    indicado: '', 
    atribuir: ''
  }
  filtroProfissional: string = ''
  profissionalName: any = {
    indicado: '',
    atribuir: ''
  }
  loadingProfissionalFilter: any = {
    indicado: false,
    atribuir: false
  }

  searchPrestador: string = ''
  loadingPrestadorFilter: boolean = false
  ignoreNextPrestadorSearch: boolean = false
  prestadoresDebounced = _.debounce(async (param: string) => {
    await this.getRegrasDeCalculoStore.getPrestadoresRepasse({ filtro: param, limite: 20 })
  }, 500)

  profissionaisDebounced = _.debounce(async (param: string, field: string) => {
    await this.getRegrasDeCalculoStore.getProfissionais({ nome: param, campo: field })
  }, 500)

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get mode() { return this.getRegrasDeCalculoStore.modeIndicacao }

  loadAddRegraCalculo: boolean = false
  get loadingAddRegraCalculo() { return this.loadAddRegraCalculo }
  set loadingAddRegraCalculo(value: boolean) { this.loadAddRegraCalculo = value }

  get showModal() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoIndicacao }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoIndicacao', value }) }

  get profissionaisExecutantesIndicado() {
    return this.getRegrasDeCalculoStore.profissionaisExecutantesIndicados
  }
  get profissionaisExecutantesAtribuir() {
    return this.getRegrasDeCalculoStore.profissionaisExecutantesAtribuidos
  }

  get prestadores() { return this.getRegrasDeCalculoStore.prestadoresRepasse }
  set prestadores(value: any) { this.getRegrasDeCalculoStore.setPrestadoresRepasse(value) }

  get getMenuInicioVigencia() { return this.menuInicioVigencia }
  set getMenuInicioVigencia(value: boolean) { this.menuInicioVigencia = value }

  get getMenuFimVigencia() { return this.menuFimVigencia }
  set getMenuFimVigencia(value: boolean) { this.menuFimVigencia = value }

  get formattedInicioVigencia() {
    const { vigenciaInicio } = this.getRegrasDeCalculoStore.regraIndicacaoItem
    if (vigenciaInicio) {
      return this.formatDate(vigenciaInicio)
    }
    return ''
  }

  get formattedFimVigencia() {
    const { vigenciaFim } = this.getRegrasDeCalculoStore.regraIndicacaoItem
    if (vigenciaFim) {
      return this.formatDate(vigenciaFim)
    }
    return ''
  }

  updateFimVigencia(date: string) {
    this.getRegrasDeCalculoStore.regraIndicacaoItem.vigenciaFim = date
  }

  updateInicioVigencia(date: string) {
    this.getRegrasDeCalculoStore.regraIndicacaoItem.vigenciaInicio = date
  }

  formatDate(vigencia: any) {
    const date = new Date(vigencia)
    if (!Number.isNaN(date.getTime())) {
      const day = String(date.getUTCDate()).padStart(2, '0')
      const month = String(date.getUTCMonth() + 1).padStart(2, '0')
      const year = date.getUTCFullYear()
      return `${day}/${month}/${year}`
    }
    console.error('Data inválida:', vigencia)
    return ''
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  onlyFloatUtil(value: number) { return onlyFloat(value) }

  async addRegra() {
    this.loadingAddRegraCalculo = true
    if (!this.$refs.form.validate()) {
      this.loadingAddRegraCalculo = false
      return
    }
    const request = await this.getRegrasDeCalculoStore.addIndicacao()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Regra incluída com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.getRegrasDeCalculoStore.setModeIndicacao('EDIT')
  }

  closeModal() {
    this.showModal = false
    this.getRegrasDeCalculoStore.clearRegraIndicacoes()
    this.$refs.form.resetValidation()
  }

  changeProfissionalExecutante(value: any, field: string) {
    if (value) {
      this.profissionalName[field] = value.nome
      if (field === 'indicado') {
        this.getRegrasDeCalculoStore.regraIndicacaoItem.profissionalExecutanteIndicadoId = value.userId
      } else {
        this.getRegrasDeCalculoStore.regraIndicacaoItem.profissionalExecutanteIdAtribuir = value.userId
      }
    } else {
      this.profissionalName[field] = ''
    }
  }

  @Watch('searchProfissional.indicado')
  async onSearchProfissionalIndicadoChanged(val: string) {
    if (!val || val.length < 3){
      return
    }
    
    if(this.profissionalName.indicado === val){
      return
    }
    
    // this.profissionalName.indicado = ''
    // this.getRegrasDeCalculoStore.regraIndicacaoItem.profissionalExecutanteIdIndicado = null
    this.loadingProfissionalFilter.indicado = true
    await this.profissionaisDebounced(val, 'indicado')
  }

  @Watch('searchPrestador')
  async onSearchPrestadorChanged(val: string) {
    if (this.ignoreNextPrestadorSearch) {
      this.ignoreNextPrestadorSearch = false
      return
    }

    if (!val || val.length < 3) {
      this.getRegrasDeCalculoStore.setPrestadoresRepasse([])
      return
    }

    this.loadingPrestadorFilter = true
    if (this.prestadoresDebounced) await this.prestadoresDebounced(val)
    this.loadingPrestadorFilter = false
  }

  @Watch('searchProfissional.atribuir')
  async onSearchProfissionalAtribuirChanged(val: string) {
    if (!val || val.length < 3){
      return
    }
    
    if(this.profissionalName.atribuir === val){
      return
    }
    
    // this.profissionalName.atribuir = ''
    // this.getRegrasDeCalculoStore.regraIndicacaoItem.profissionalExecutanteIdAtribuir = null    
    this.loadingProfissionalFilter.atribuir = true
    await this.profissionaisDebounced(val, 'atribuir')
  }

  @Watch('profissionaisExecutantesIndicado')
  onChangeProfissionaisExecutanteIndicado(value) {
    if (value) this.loadingProfissionalFilter.indicado = false
  }

  @Watch('profissionaisExecutantesAtribuir')
  onChangeProfissionaisExecutanteAtribuir(value) {
    if (value) this.loadingProfissionalFilter.atribuir = false
  }

  @Watch('showModal')
  async onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.clearRegraIndicacoes()
      this.$refs.form.resetValidation()
    } else {
      const item = this.getRegrasDeCalculoStore.regraIndicacaoItem
      
      if (item.profissionalExecutanteIndicadoId){
        const obj = {
          userId: item.profissionalExecutanteIndicadoId,
          nome: item.profissionalExecutanteIndicadoNome
        }

        this.profissionalName.indicado = item.profissionalExecutanteIndicadoNome
        this.getRegrasDeCalculoStore.setProfissionaisExecutantesIndicados([obj])
        this.loadingProfissionalFilter.indicado = false
        this.getRegrasDeCalculoStore.regraIndicacaoItem.profissionalExecutanteIndicadoId = item.profissionalExecutanteIndicadoId
      }

      if (item.profissionalExecutanteIdAtribuir){
        const obj = {
          userId: item.profissionalExecutanteIdAtribuir,
          nome: item.profissionalExecutanteAtribuirNome
        }

        this.profissionalName.atribuir = item.profissionalExecutanteAtribuirNome
        this.getRegrasDeCalculoStore.setProfissionaisExecutantesAtribuidos([obj])
        this.loadingProfissionalFilter.atribuir = false
        this.getRegrasDeCalculoStore.regraIndicacaoItem.profissionalExecutanteIdAtribuir = item.profissionalExecutanteIdAtribuir
      }

      this.prestadores = [{
        userId: item.prestadorIndicadorId,
        nome: item.prestadorIndicadorNome
      }]
    }
  }

  onChangePrestador() {
    this.ignoreNextPrestadorSearch = true
  }
}
